import loadable from '@loadable/component';
import Layout from '../layouts/LoggedOut';
import type { RedirectProps, RouteProps } from '.';

/* istanbul ignore file */

export const routes: Array<RouteProps> = [
  {
    path: '/__maintenance',
    exact: true,
    component: loadable(() => import(/* webpackChunkName: "maintenance" */ '../pages/Maintenance')),
    layout: Layout,
  },
  {
    path: '/__components',
    exact: true,
    component: loadable(() => import(/* webpackChunkName: "components" */ '../pages/Components')),
    layout: Layout,
  },
];

export const redirects: Array<RedirectProps> = [];
